import type { party_enum } from '@vrplatform/graphql';
import type { TrustReconciliationByListingTableQueryRow } from './useTrustReconciliationByListingTableQuery';

const MANAGER_PARTY_ROW_NAMES = new Set([
  'manager balances',
  'manager payable',
]);
const OWNER_PARTY_ROW_NAMES = new Set(['owner balances', 'owner payable']);

export const inferTrustReconciliationByListingParty = (
  rowName: string
): party_enum | undefined => {
  const normalizedRowName = rowName.trim().toLowerCase();

  if (MANAGER_PARTY_ROW_NAMES.has(normalizedRowName)) return 'manager';
  if (OWNER_PARTY_ROW_NAMES.has(normalizedRowName)) return 'owners';

  return undefined;
};

const populateRowParty = (
  row: TrustReconciliationByListingTableQueryRow,
  inheritedParty: party_enum | undefined
): TrustReconciliationByListingTableQueryRow => {
  const party =
    inferTrustReconciliationByListingParty(row.name) ?? inheritedParty;

  return {
    ...row,
    party,
    subRows: row.subRows.map((subRow) => populateRowParty(subRow, party)),
  };
};

export const populateTrustReconciliationByListingRowParties = (
  rows: TrustReconciliationByListingTableQueryRow[]
): TrustReconciliationByListingTableQueryRow[] => {
  return rows.map((row) => populateRowParty(row, undefined));
};
